export default {
  "1": {
    id: 1,
    answer: "c",
  },
  "2": {
    id: 2,
    answer: "a",
  },
  "3": {
    id: 3,
    answer: "d",
  },
  "4": {
    id: 4,
    answer: "c",
  },
  "5": {
    id: 5,
    answer: "a",
  },
  "6": {
    id: 6,
    answer: "c",
  },
  "7": {
    id: 7,
    answer: "b",
  },
  "8": {
    id: 8,
    answer: "a",
  },
  "9": {
    id: 9,
    answer: "d",
  },
  "10": {
    id: 10,
    answer: "d",
  },
  "11": {
    id: 11,
    answer: "a",
  },
  "12": {
    id: 12,
    answer: "b",
  },
  "13": {
    id: 13,
    answer: "a",
  },
  "14": {
    id: 14,
    answer: "b",
  },
  "15": {
    id: 15,
    answer: "a",
  },
  "16": {
    id: 16,
    answer: "a",
  },
  "17": {
    id: 17,
    answer: "a",
  },
  "18": {
    id: 18,
    answer: "d",
  },
  "19": {
    id: 19,
    answer: "b",
  },
  "20": {
    id: 20,
    answer: "d",
  },
  "21": {
    id: 21,
    answer: "a",
  },
  "22": {
    id: 22,
    answer: "a",
  },
  "23": {
    id: 23,
    answer: "b",
  },
  "24": {
    id: 24,
    answer: "d",
  },
  "25": {
    id: 25,
    answer: "b",
  },
  "26": {
    id: 26,
    answer: "c",
  },
  "27": {
    id: 27,
    answer: "c",
  },
  "28": {
    id: 28,
    answer: "a",
  },
  "29": {
    id: 29,
    answer: "a",
  },
  "30": {
    id: 30,
    answer: "d",
  },
};
